import { createReducer, on } from '@ngrx/store';
import { RoleThatFits } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-profile.model';
import {
  loadRolesThatFit,
  loadRolesThatFitError,
  loadRolesThatFitSuccess,
} from './roles-that-fit.actions';

export interface RolesThatFitState {
  roles: RoleThatFits[];
  loading: boolean;
  loaded: boolean;
}

const initialState: RolesThatFitState = {
  roles: [],
  loading: false,
  loaded: false,
};

export const rolesThatFitReducer = createReducer(
  initialState,
  on(loadRolesThatFit, () => ({ roles: [], loading: true, loaded: false })),
  on(loadRolesThatFitSuccess, (state, { roles }) => ({
    ...state,
    roles,
    loading: false,
    loaded: true,
  })),
  on(loadRolesThatFitError, (state) => ({ ...state, loading: false })),
);
